import { useEffect, useRef, useState } from 'react';
import { baseUrl } from './useFetch';

interface MeetingNotification {
    meetingId: number;
    title: string;
    date: string;
    startTime: string;
    mode: string;
    meetingLink?: string;
    minutesLeft: number;
}

export const useMeetingReminder = (token: string | undefined) => {
    const [reminderMeeting, setReminderMeeting] = useState<MeetingNotification | null>(null);
    const dismissedRef = useRef<Set<string>>(new Set());

    const checkUpcomingMeetings = async () => {
        if (!token) return;
        try {
            const timeZoneId = Intl.DateTimeFormat().resolvedOptions().timeZone;
            const res = await fetch(`${baseUrl}Meetings/meetingNotification?timeZoneId=${timeZoneId}`, { headers: { Authorization: `Bearer ${token}` } });
            const data = await res.json();
            if (!data.success || !Array.isArray(data.notifications)) return;
            const now = new Date();

            const upcoming = data.notifications.find((n: any) => {
                if (!n.meetingId || !n.startTime || !n.date)
                    return false;
                const meetingDateTime = new Date(`${n.date}T${n.startTime}`);
                const diffMs = meetingDateTime.getTime() - now.getTime();
                const diffMinutes = Math.floor(diffMs / 60000);

                const key = `${n.meetingId}-${diffMinutes}`;
                if (diffMinutes > 0 && diffMinutes <= 10 && !dismissedRef.current.has(key)) {
                    n.minutesLeft = diffMinutes;
                    return true;
                }
                return false;
            });

            if (upcoming) {
                setReminderMeeting(upcoming);
            }
        } catch (err) {
            console.error('Meeting reminder check failed', err);
        }
    };

    useEffect(() => {
        if (!token) return;
        checkUpcomingMeetings();
        const interval = setInterval(checkUpcomingMeetings, 1 * 60 * 1000);
        return () => clearInterval(interval);
    }, [token]);

    const dismissReminder = () => {
        if (reminderMeeting) {
            const key = `${reminderMeeting.meetingId}-${reminderMeeting.minutesLeft}`;
            dismissedRef.current.add(key);
            setReminderMeeting(null);
        }
    };

    return { reminderMeeting, dismissReminder };
};